import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/FAQSection.css';

const FAQ_KEYS = [
    'splitPayments',
    'guestAccount',
    'whenReceive',
    'failedInstallment',
    'blessing',
    'futurePayments',
    'secure',
    'languages',
] as const;

const FAQSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="faq" className="landing-section" aria-labelledby="faq-heading">
            <div className="landing-container">
                <SectionHeader title={t('faq.title')} id="faq-heading" />
                <div className="faq-section__list">
                    {FAQ_KEYS.map((key) => (
                        <details key={key} className="faq-section__item">
                            <summary className="faq-section__question">
                                {t(`faq.items.${key}.q`)}
                            </summary>
                            <p className="faq-section__answer">{t(`faq.items.${key}.a`)}</p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
